import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Slide,
  useMediaQuery,
  useTheme,
  Button,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  size = "md",
  showCloseButton = true,
  maxWidth,
  fullWidth = true,
  disableEscapeKeyDown = false,
  className = "",
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const sizeMap = {
    sm: "xs",
    md: "sm",
    lg: "md",
    xl: "lg",
    full: "xl",
  };

  return (
    <Dialog
      open={isOpen}
      onClose={(_, reason) => {
        if (disableEscapeKeyDown && reason === "escapeKeyDown") return;
        onClose();
      }}
      maxWidth={maxWidth || sizeMap[size]}
      fullWidth={fullWidth}
      fullScreen={fullScreen}
      scroll="paper"
      keepMounted
      TransitionComponent={Transition}
      PaperProps={{
        className,
        sx: {
          borderRadius: 3,
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          boxShadow: 24,
        },
      }}
    >
      {(title || showCloseButton) && (
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 2,
            px: 3,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            {title}
          </Typography>

          {showCloseButton && (
            <IconButton onClick={onClose} size="small">
              <CloseIcon />
            </IconButton>
          )}
        </DialogTitle>
      )}

      <DialogContent
        dividers
        sx={{
          p: 3,
          overflowY: "auto",
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};

export const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm",
  message = "Are you sure?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "error",
  loading = false,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <Box>
        <Typography sx={{ mb: 3 }}>{message}</Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
          }}
        >
          <Button variant="outlined" onClick={onClose} disabled={loading}>
            {cancelText}
          </Button>

          <Button
            variant="contained"
            color={confirmVariant}
            onClick={onConfirm}
            disabled={loading}
            startIcon={
              loading ? <CircularProgress size={18} color="inherit" /> : null
            }
          >
            {loading ? "Processing..." : confirmText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default Modal;
